module.exports = __webpack_public_path__ + "img/right-banner01.5bd9c533.png";